import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpEventType, HttpResponse } from '@angular/common/http';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { NotificationService } from '../../service/notification.service';
import { NotificationType } from '../../enum/notification-type.enum';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { UploadJsonService } from '../../service/upload-json.service';
import { UploadJsonModel } from '../../models/commissionsummary/upload-json.model';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import * as XLSX from 'xlsx';
import { FormControl, NgForm } from '@angular/forms';
import { CommSummaryModel } from 'src/app/models/commissionsummary/commsummary.model';
import { CommissionSummaryService } from 'src/app/service/commission-summary.service';
import { map, startWith } from 'rxjs/operators';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { GlobalService } from 'src/app/service/global.service';
import { UploadJsonHeadersModel } from 'src/app/models/commissionsummary/upload-json-headers.model';
import { ExcelHeadersService } from 'src/app/service/excelheaders.service';
import { ExcelHeadersModel } from 'src/app/models/excelheaders/excelheaders.model';

@Component({
  selector: 'app-upload-headers',
  templateUrl: './upload-headers.component.html',
  styleUrls: ['./upload-headers.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class UploadHeadersComponent implements OnInit {

  selectedFiles: FileList;
  currentFile: File;
  message = '';

  public dataSource = new MatTableDataSource<UploadJsonModel>();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('TABLE') table: ElementRef;

  public displayedColumns = ['page_name', 'grid_name', 'order', 'sql', 'commPlanId', 'salesChannel', 'kpiId', 'update', 'view', 'download'];
  public expandedElement: null;
  public showLoading: boolean;
  public commSummaryModel = new CommSummaryModel();

  private subscriptions: Subscription[] = [];
  public refreshing: boolean;
  public pageResponse: UploadJsonModel[] = [];

  public fileInfos: Observable<any>;
  public sc: string;
  public commPlanId: number;
  public commplans: UploadJsonModel[];

  public uploadJsonModel = new UploadJsonModel();
  public uploadJsonModelEdit = new UploadJsonModel();
  public uploadJsonModelEdit1 = new UploadJsonModel();
  public uploadJsonModelClone = new UploadJsonModel();

  public kpisData: UploadJsonModel[] = [];
  public comPlanData: UploadJsonModel[] = [];
  public reportTypesData: ExcelHeadersModel[] = [];
  public jsonModels: UploadJsonModel[] = [];

  dropDownsData: CommSummaryModel[] = [];
  headersGroupData: UploadJsonModel[] = [];
  headersGroupDataEdit: UploadJsonModel[] = [];
  filteredSalesChannelsData: CommSummaryModel[] = [];
  filteredCommPlansData: CommSummaryModel[] = [];
  filteredCommPlansDataClone: CommSummaryModel[] = [];
  filteredCommPlansDataEdit: CommSummaryModel[] = [];
  public salesChannels: UploadJsonModel[] = [];

  filteredSalesChannelValues: Observable<CommSummaryModel[]> | undefined;
  controlSc = new FormControl();
  filteredCommissionPlans: Observable<CommSummaryModel[]> | undefined;
  controlCp = new FormControl();
  filteredKpiValues: Observable<UploadJsonModel[]> | undefined;
  controlKpi = new FormControl();

  filteredSalesChannelValuesEdit: Observable<CommSummaryModel[]> | undefined;
  controlScEdit = new FormControl();
  filteredCommissionPlansEdit: Observable<CommSummaryModel[]> | undefined;
  controlCpEdit = new FormControl();
  filteredKpiValuesEdit: Observable<UploadJsonModel[]> | undefined;
  controlKpiEdit = new FormControl();

  filteredSalesChannelValuesClone: Observable<CommSummaryModel[]> | undefined;
  controlScClone = new FormControl();
  filteredCommissionPlansClone: Observable<CommSummaryModel[]> | undefined;
  controlCpClone = new FormControl();


  columnsExcelData: any;
  dataForExcel = [];
  ordersTableExcelHeaderColumns: TableColumn[];

  uploadJsonData: ExcelHeadersModel[] = [];

  // GRID FRAMEWORK
  ordersTableColumns1: TableColumn[];
  ordersTableColumns2: TableColumn[];
  ordersTableColumns3: TableColumn[];

  columnsData: any;
  actions: any;
  actionButtons: any;

  isAccessDisabled: boolean = false;

  public headersEditModels: ExcelHeadersModel[] = [];
  public buttonsEditModels: ExcelHeadersModel[] = [];
  public uploadJsonHeadersModel = new ExcelHeadersModel();

  jid: number = 0;

  constructor(
    private globalService: GlobalService,
    private httpService: HttpClient,
    private router: Router,
    private excelHeadersService: ExcelHeadersService,
    public ete: ExportExcelService,
    private notificationService: NotificationService,
    private commissionSummaryService: CommissionSummaryService
  ) { }

  ngOnInit(): void {
    //Get Permissions
    this.isAccessDisabled = this.globalService._permissionCheck('upload-json');

    if (this.isAccessDisabled === true) {
      this.controlScEdit.disable();
      this.controlCpEdit.disable();
      this.controlKpiEdit.disable();
      this.controlScClone.disable();
      this.controlCpClone.disable();
    }

    this.initializeColumns();
    this.getReportTypes();
    this.getJsonsList('a', 0);

    this.uploadJsonModelEdit.created_by = "";
    this.uploadJsonModelEdit.created_dt = new Date();
    this.jsonModels.push(this.uploadJsonModelEdit);
  }

  public getJsonsList(sc: string, commPlanId: number): void {
    console.log("Inside getJsonsList()");
    this.subscriptions.push(
      this.excelHeadersService.getJsonsList(sc, commPlanId).subscribe(
        (response: ExcelHeadersModel[]) => {
          //this.dataSource.data = response as UploadJsonModel[];
          this.uploadJsonData = response;
        },
        (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  public getReportTypes(): void {
    this.subscriptions.push(
      this.excelHeadersService.getReportTypes().subscribe(
        (response: ExcelHeadersModel[]) => {
          this.reportTypesData = response;
        },
        (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }


  uploadJSON() {
    console.log(this.uploadJsonModel.kpiId);
    console.log(this.uploadJsonModel.commPlanId);

    if (this.uploadJsonModel.kpiId === null) {
      this.uploadJsonModel.kpiId = 0;
    }
    this.excelHeadersService.uploadJSON(this.currentFile, this.uploadJsonModel.gridName, this.uploadJsonModel.sql, this.uploadJsonModel.pageName,
      this.uploadJsonModel.colSort, this.uploadJsonModel.kpiId, this.uploadJsonModel.report_type, this.uploadJsonModel.description, this.uploadJsonModel.commPlanId).subscribe(
        event => {
          //eventForm.reset();
          this.getJsonsList('a', 0);
          this.clickButton('new-trans-close');
          this.notificationService.sendNotification(NotificationType.SUCCESS, 'Uploaded Successfully');
        },
        err => {
          this.notificationService.sendNotification(NotificationType.ERROR, 'Something went wrong!');
          this.message = 'Something went wrong!';
        });
  }

  updateJson() {
    let vkpiid = "";
    let vcomplan = "";
    for (let val of this.jsonModels) {
      vkpiid = vkpiid + val.kpiId + ",";
      vcomplan = vcomplan + val.commPlanId + ",";
    }
    console.log(vkpiid);
    console.log(vcomplan);
    // if (this.currentFile === undefined) {
    this.excelHeadersService.updateJSONWithoutFile(this.uploadJsonModelEdit.gridName, this.uploadJsonModelEdit.sql,
      this.uploadJsonModelEdit.pageName, this.uploadJsonModelEdit.colSort, vcomplan,
      this.uploadJsonModelEdit.salesChannel, vkpiid, this.uploadJsonModelEdit.id).subscribe(
        event => {
          this.getJsonsList('a', 0);
          this.clickButton('new-trans-update-close');
          this.notificationService.sendNotification(NotificationType.SUCCESS, 'Uploaded Successfully');
        },
        err => {
          this.notificationService.sendNotification(NotificationType.ERROR, 'Failed To Update!');
          this.message = 'Failed To Update!';
        });

  }


  public getHeaders(id: number) {
    console.log(id);
    this.jid = id;
    this.subscriptions.push(
      this.excelHeadersService.fetchHeaders(id).subscribe(
        (response: ExcelHeadersModel[]) => {
          this.headersEditModels = response;
          console.log(this.headersEditModels);
          if (this.headersEditModels.length === 0) {
            this.uploadJsonHeadersModel.created_by = "";
            this.uploadJsonHeadersModel.created_dt = new Date();
            this.headersEditModels.push(this.uploadJsonHeadersModel);
          }
          this.getButtons(id);
        },
        (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  updateHeaders() {
    this.headersEditModels[0].jsonsqlid = this.jid;
    console.log(this.headersEditModels);
    this.excelHeadersService.updateHeaders(this.headersEditModels)
      .subscribe((data: ExcelHeadersModel[]) => {
        this.getJsonsList('a', 0);
        this.notificationService.sendNotification(NotificationType.SUCCESS, 'Updated Successfully');
      },
        (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        });
  }

  public getButtons(id: number) {
    console.log(id);
    this.jid = id;
    this.subscriptions.push(
      this.excelHeadersService.fetchButtons(id).subscribe(
        (response: ExcelHeadersModel[]) => {
          this.buttonsEditModels = response;
          console.log(this.buttonsEditModels);
          if (this.buttonsEditModels.length === 0) {
            this.uploadJsonHeadersModel.created_by = "";
            this.uploadJsonHeadersModel.created_dt = new Date();
            this.buttonsEditModels.push(this.uploadJsonHeadersModel);
          }
        },
        (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  updateButtons() {
    this.buttonsEditModels[0].jsonsqlid = this.jid;
    console.log(this.buttonsEditModels);
    this.excelHeadersService.updateButtons(this.buttonsEditModels)
      .subscribe((data: ExcelHeadersModel[]) => {
        this.getJsonsList('a', 0);
        this.notificationService.sendNotification(NotificationType.SUCCESS, 'Updated Successfully');
      },
        (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        });
  }

  cloneData() {
    //alert(this.sc + "-" + this.uploadJsonModelEdit.commPlanId);
    //alert(this.uploadJsonModelClone.salesChannel + "-" + this.uploadJsonModelClone.commPlanId);

    if (this.uploadJsonModelClone.salesChannel === null || this.uploadJsonModelClone.commPlanId === null) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please select both fields');
    } else if (this.sc === this.uploadJsonModelClone.salesChannel && this.uploadJsonModelEdit.commPlanId === this.uploadJsonModelClone.commPlanId) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Already exists. Choose different');
    } else {
      this.excelHeadersService.cloneData(this.sc, this.uploadJsonModelEdit.commPlanId, this.uploadJsonModelClone.commPlanId, this.uploadJsonModelClone.salesChannel).subscribe(
        event => {
          this.clickButton('clone-close');
          this.notificationService.sendNotification(NotificationType.SUCCESS, 'Cloned Successfully');
        },
        err => {
          this.notificationService.sendNotification(NotificationType.ERROR, 'Failed!');
        });
    }
  }

  private _normalizeValue(value: string): string {
    if (value)
      return value.toString().toLowerCase().replace(/\s/g, '');
    else
      return '';
  }

  showJson(json: string, page_name: string) {
    //console.log("comm_doc value ==== "+atob(comm_doc));
    //console.log("comm_doc encode value ==== "+encodeURI(comm_doc));
    let pdfWindow = window.open("");
    pdfWindow.document.write("<html<head><title>" + page_name + "</title><style>body{margin: 0px;}iframe{border-width: 0px;}</style></head>");
    pdfWindow.document.write("<body><embed width='100%' height='100%' src='data:application/json;base64, " + encodeURI(json) + "#toolbar=0&navpanes=0&scrollbar=0'></embed></body></html>");
  }

  downloadJson(json: string, page_name: string) {
    const linkSource = 'data:application/json;base64,' + json;
    const downloadLink = document.createElement("a");
    const fileName = page_name;
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }


  public saveNewTrans(): void {
    this.clickButton('new-trans-save');
  }
  public cloneNewTrans(): void {
    this.clickButton('new-trans-clone');
  }
  public updateNewTrans(): void {
    this.clickButton('new-trans-update');
  }



  public onEditJson(jsonModel: UploadJsonModel): void {
    this.uploadJsonModelEdit = jsonModel;
    this.getHeaders(jsonModel.id);
    this.clickButton('Edit');
  }

  public cloneCommPlan(jsonModel: UploadJsonModel): void {
    this.uploadJsonModelEdit = jsonModel;
    this.clickButton('Clone');
  }



  addNewHeaderEditRow(kpiForm: NgForm) {
    const headerObj = new ExcelHeadersModel();
    headerObj.name = this.uploadJsonHeadersModel.name;
    headerObj.dataKey = this.uploadJsonHeadersModel.dataKey;
    headerObj.position = this.uploadJsonHeadersModel.position;

    this.headersEditModels.push(headerObj);
    //console.log("add kpiEditModels = " + JSON.stringify(this.kpiEditModels));
  }
  public removeHeaderEditRow(index: any) {
    if (this.headersEditModels.length > 1) {
      if (this.headersEditModels[index].name != null) {
        this.removeHeaderEditFilterData(index);
      }
      else {
        this.removeHeaderEditFilterData(index);
        this.headersEditModels.splice(index, 1);
      }
    } else {
      this.notificationService.sendNotification(NotificationType.WARNING, "There Is Only One Row Exist You Can't Delete.");
    }
  }
  private removeHeaderEditFilterData(i: any) {
    if (this.headersEditModels.length > 0) {
      const compos = this.headersEditModels[i].name;
      this.headersEditModels.forEach((value: any, index: any) => {
        if (value.name == compos)
          this.headersEditModels.splice(index, 1);
      })
    }
  }


  // buttons
  addNewButtonsEditRow(kpiForm: NgForm) {
    const headerObj = new ExcelHeadersModel();
    headerObj.name = this.uploadJsonHeadersModel.name;

    this.buttonsEditModels.push(headerObj);
    //console.log("add kpiEditModels = " + JSON.stringify(this.kpiEditModels));
  }
  public removeButtonsEditRow(index: any) {
    if (this.buttonsEditModels.length > 1) {
      if (this.buttonsEditModels[index].name != null) {
        this.removeButtonsEditFilterData(index);
      }
      else {
        this.removeButtonsEditFilterData(index);
        this.buttonsEditModels.splice(index, 1);
      }
    } else {
      this.notificationService.sendNotification(NotificationType.WARNING, "There Is Only One Row Exist You Can't Delete.");
    }
  }
  private removeButtonsEditFilterData(i: any) {
    if (this.buttonsEditModels.length > 0) {
      const compos = this.buttonsEditModels[i].name;
      this.buttonsEditModels.forEach((value: any, index: any) => {
        if (value.name == compos)
          this.buttonsEditModels.splice(index, 1);
      })
    }
  }

  hideRemainingLabels(id: number): boolean {
    if (id === 0)
      return true;
    else
      return false;
  }

  addNewRow(missingForm: NgForm) {
    const kpiObj = new UploadJsonModel();
    kpiObj.kpiId = this.uploadJsonModelEdit1.kpiId;
    //kpiObj.comm_plan_id = this.uploadJsonModelEdit1.comm_plan_id;
    this.jsonModels.push(kpiObj);
    console.log(this.jsonModels);
  }

  public removeRow(index: any) {
    if (this.jsonModels.length > 1) {
      if (this.jsonModels[index].kpiId != null) {
        this.removeFilterData(index);
      } else {
        this.removeFilterData(index);
        //this.kpiModels.splice(index, 1);
      }
    } else {
      this.notificationService.sendNotification(NotificationType.WARNING, "There Is Only One Row Exist You Can't Delete.");
    }
  }

  private removeFilterData(i: any) {

    if (this.jsonModels.length > 0) {
      const compos = this.jsonModels[i].kpiId;
      this.jsonModels.forEach((value: any, index: any) => {
        if (value.kpiId == compos)
          this.jsonModels.splice(index, 1);
      })
    }
    console.log(this.jsonModels);
  }


  // GRID FRAMEWORK
  innerRowAction1(row: any) {
    console.log(" row ....", row.row.salesChannel, "=== val  ", row.value);

    if (row.value === 'View') {
      //this.getSalesChannelName(row.row.salesChannel);
    }

    if (row.value === 'Update') {
      //this.downloadPdf(row.row.comm_doc_str,row.row.doc_name)
      console.log(row.row);
      this.onEditJson(row.row);

    }

  }
  innerRowAction2(row: any) {
    console.log(" row ....", row.row.commPlanId, "=== val  ", row.value);

    if (row.value === 'View') {
      //this.getCommPlanId(row.row.commPlanId);
    }

    if (row.value === 'Clone') {
      this.cloneCommPlan(row.row);
    }

  }
  innerRowAction3(row: any) {
    console.log(" row ....", row.row.id, "=== val  ", row.value);
    if (row.value === 'Update') {
      //this.downloadPdf(row.row.comm_doc_str,row.row.doc_name)
      console.log(row.row);
      this.onEditJson(row.row);

    }
    if (row.value === 'Display') {
      //this.downloadPdf(row.row.comm_doc_str,row.row.doc_name)
      this.showJson(row.row.jsonStr, row.row.pageName);
    }
    if (row.value === 'JSON') {
      this.downloadJson(row.row.jsonStr, row.row.pageName);
    }

  }

  actionOnButton(action: any) {
    if (action === "Add SQL") {
      if (this.isAccessDisabled === true) {
        this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
      } else {
        this.clickButton(action);
      }
    }
  }

  private clickButton(buttonId: string): void {
    document.getElementById(buttonId).click();
  }


  initializeColumns(): void {
    this.httpService.get('../../../assets/json/tableColumns.json').subscribe(
      data => {
        this.columnsData = data;
        //this.ordersTableColumns1 = this.columnsData.uploadJsonSalesChannel;
        // this.ordersTableColumns2 = this.columnsData.uploadJsonCommPlans;
        this.ordersTableColumns3 = this.columnsData.uploadJson;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
    this.actions = [
      {
        name: 'Update',
        dataKey: 'far fa-edit success f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-success'
      },
      {
        name: 'Clone',
        dataKey: 'fas fa-clone success f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-danger'
      }
    ]

    this.actionButtons = [
      {
        name: 'Add SQL',
        class: 'btn btn-success btn-xs'
      }
    ]
  }
}
